import { render } from "./FormControlErrors.vue?vue&type=template&id=45f2225c"
import script from "./FormControlErrors.vue?vue&type=script&lang=js"
export * from "./FormControlErrors.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__